import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import {
    Activation,
    Equipment,
    Fai,
    FaimUnlimited,
    Installation,
    Plan,
    ProductFactory,
    QuoteModel,
} from '@bytel/bytel-sales';
import { ProductService } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';

import { EquipmentLabelPipe } from '@shared/pipes/equipment-label.pipe';

import { LazyLoadImageModule } from 'ng-lazyload-image';
import { Subject, of } from 'rxjs';
import { catchError, finalize, takeUntil } from 'rxjs/operators';

import { ProductHelper } from '../../../../catalog/product-helper';

@Component({
    selector: 'checkout-fai-box',
    templateUrl: './fai-box.component.html',
    styleUrl: 'fai-box.component.scss',
    standalone: true,
    imports: [LazyLoadImageModule],
})
export class FaiBoxComponent implements OnInit, OnDestroy {
    @Input() public quoteIndex: number = 0;

    public equipment: Equipment;
    public activation: Activation;
    public defaultImage: string;
    public installation: Installation;
    public fai: Fai;
    public quote: QuoteModel;
    public images: string;
    public description: string;
    public isLoading: boolean = false;
    private _ngUnsubscribe = new Subject();

    constructor(
        protected cartService: MainCartService,
        protected productService: ProductService,
        protected productHelper: ProductHelper,
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.quote = this.cartService.getQuote(this.quoteIndex);
        this.equipment = this.quote.getPrincipalProduct<Equipment>('Equipment');
        const plan: Plan = this.quote.getPrincipalProduct<Plan>('Plan');

        // TODO: chargement du bloc x2 - trouver solution pour empecher le double appel
        if (ProductFactory.Is(plan, FaimUnlimited) && plan.productPrio) {
            this.productService
                .getProductByGencode(plan.productPrio)
                .pipe(
                    takeUntil(this._ngUnsubscribe),
                    finalize(() => (this.isLoading = false)),
                    catchError(() => of(null)),
                )
                .subscribe((product) => {
                    if (product) {
                        this.fai = product as FaimUnlimited;
                        this.description = product.label;
                    }
                    this._reloadData();
                });
        } else {
            this._reloadData();
        }
    }

    ngOnDestroy(): void {
        this._ngUnsubscribe.next(null);
        this._ngUnsubscribe.complete();
    }

    private _reloadData(): void {
        const labelPipe = new EquipmentLabelPipe();
        this.fai = this.fai ?? this.quote.getPrincipalProduct<Fai>('Fai');
        this.description = this.description ?? labelPipe.transform(this.fai.equipment);
        this.defaultImage = this.productHelper.getDefaultImage(this.fai);
        this.images = this.productHelper.getImages(this.fai);
    }
}
